import { useSelector } from 'react-redux';
import { ROLES } from '@constants';

export default function useIsSuperAdmin() {
  const role = useSelector((state) => state.auth.role);
  const isSuperAdmin = role?.includes(ROLES.ADMIN_ROLE);

  return isSuperAdmin;
}
